import React from 'react';
import { assetUrl } from '../../../utils/assets';

interface FullscreenLoadingProps {
    message?: string;
}

const FullscreenLoading: React.FC<FullscreenLoadingProps> = ({ message = "Loading..." }) => {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-4">
            <img src={assetUrl('logo-linksehat.png')} alt="Loading" className="w-20 h-20 animate-pulse" />
            {/* <div className="w-12 h-12 animate-spin rounded-full border-4 border-red-500 border-t-transparent"></div> */}
            
            <p className="text-white text-sm">{message}</p>
            </div>
        </div> 
    );
};

export default FullscreenLoading;
